/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsListForStationQueryResponse, StationsStationsGroupsListForStationPathParams } from "../models/StationsStationsGroupsListForStation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationsStationsGroupsListForStation } from "../axios/stationsStationsGroupsListForStation";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationsStationsGroupsListForStationQueryKey = (stationId: StationsStationsGroupsListForStationPathParams["stationId"]) => ["api-v2", { url: '/station-groups/v1/stations/:stationId', params: {stationId:stationId} }] as const

export type StationsStationsGroupsListForStationQueryKey = ReturnType<typeof stationsStationsGroupsListForStationQueryKey>

export function stationsStationsGroupsListForStationQueryOptions(stationId: StationsStationsGroupsListForStationPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = stationsStationsGroupsListForStationQueryKey(stationId)
        return queryOptions<StationsStationsGroupsListForStationQueryResponse, ResponseErrorConfig<Error>, StationsStationsGroupsListForStationQueryResponse, typeof queryKey>({
         enabled: !!(stationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return stationsStationsGroupsListForStation(stationId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all stations groups that include the given station.
 * @summary List stations groups for station
 * {@link /station-groups/v1/stations/:stationId}
 */
export function useStationsStationsGroupsListForStation<TData = StationsStationsGroupsListForStationQueryResponse, TQueryData = StationsStationsGroupsListForStationQueryResponse, TQueryKey extends QueryKey = StationsStationsGroupsListForStationQueryKey>(stationId: StationsStationsGroupsListForStationPathParams["stationId"], options: 
{
  query?: Partial<QueryObserverOptions<StationsStationsGroupsListForStationQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? stationsStationsGroupsListForStationQueryKey(stationId)
         

         const query = useQuery({
          ...stationsStationsGroupsListForStationQueryOptions(stationId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}